import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from '../../store/store';
import type { MessageState } from '../../types/messageState';

export interface MessageStateSliceState {
  byKey: Record<string, MessageState>;
}

const initialState: MessageStateSliceState = {
  byKey: {},
};

const messageStateSlice = createSlice({
  name: 'messageState',
  initialState,
  reducers: {
    setAllMessageStates: (state, action: PayloadAction<MessageState[]>) => {
      state.byKey = action.payload.reduce<Record<string, MessageState>>(
        (byKey, messageState) => {
          byKey[messageState.messageKey] = messageState;
          return byKey;
        },
        {}
      );
    },
    upsertMessageState: (state, action: PayloadAction<MessageState>) => {
      const incoming = action.payload;
      const current = state.byKey[incoming.messageKey];
      // Monotonic: never let an out-of-order write (e.g. a late `in_progress`
      // start landing after a `completed`) overwrite a newer row locally.
      if (
        current &&
        Date.parse(current.updatedAt) > Date.parse(incoming.updatedAt)
      ) {
        return;
      }
      state.byKey[incoming.messageKey] = incoming;
    },
  },
});

export const { setAllMessageStates, upsertMessageState } =
  messageStateSlice.actions;

export const selectMessageStateByKey = (state: RootState, key: string) =>
  state.messageState.byKey[key];

export default messageStateSlice.reducer;
